/*
 * (c) KSI Media / dlaoperatora.pl 2022
 */
class KSICRM{
  
  constructor( custoperKSIPageUrl ){
    if ( custoperKSIPageUrl === undefined ) {
       this.pageUrl = "https://demo.dlaoperatora.pl/" ;
    } else {
      this.pageUrl = custoperKSIPageUrl ;  
    }
    // PopupWindow
    var wndHTML = "<div id='ksi-popup-window-bg' style='display:none;'><div id='ksi-popup-window' style='display:none;'><div id='ksi-popup-title'>Default uiPopUp Window Title</div><div id='ksi-popup-btn-close'>x</div><div id='ksi-popup-content'>Example content.</div></div></div>" ;
    var elem = document.createElement('div');
    elem.innerHTML = wndHTML ;
    document.body.appendChild(elem);    

    this.wnd = document.getElementById ( 'ksi-popup-window' ) ;
    this.btnClose = document.getElementById ( 'ksi-popup-btn-close' ) ;
    this.title = document.getElementById ( 'ksi-popup-title' ) ;
    this.content = document.getElementById ( 'ksi-popup-content' ) ;    
    this.spinImage = `<img id='ksi-spin-image' style='position:absolute;top:calc(50% - 60px);left:calc(50% - 30px);width:120px;height:120px;' src='${this.pageUrl}/data/images/Spin.svg' alt='Proszę czekać'>` ;
    
    var self = this ;
    this.btnClose.addEventListener ( 'click', function(){self.close();} );
        
    window.addEventListener ( 'resize', ()=>{ this.updateWindowSize(); });
    window.addEventListener ( 'load', ()=>{ this.updateWindowSize(); });
    window.addEventListener ( 'scroll', ()=>{ this.updateWindowSize(); });
    
  }
     
  updateWindowSize(){
    this.wnd.style.width = null ;
    this.wnd.style.height = null ;
    setTimeout( ()=>{
      let width = Math.round ( parseInt ( window.getComputedStyle( this.wnd ).width, 10 ) ) ;
      let height = Math.round ( parseInt ( window.getComputedStyle( this.wnd ).height, 10 ) ) ;
      if ( width % 2 !== 0 ) width = width - 1 ;
      if ( height % 2 !== 0 ) height = height - 1 ;
      this.wnd.style.width = width.toString()+'px';
      this.wnd.style.height = height.toString()+'px';        
    }, 10 );    
  }
     
  close(){
    this.wnd.style.display = 'none';
    this.wnd.parentElement.style.display = 'none';
    this.content.innerHTML = '' ;
    this.title.innerHTML = '&nbsp;' ;
  }
  
  open( title, content ){
    this.content.innerHTML = content ;
    this.title.innerHTML = title+'&nbsp;' ;
    this.wnd.style.display = 'block';
    this.wnd.parentElement.style.display = 'block';
    setTimeout ( ()=>{this.updateWindowSize();}, 20 );
    let ifr = document.getElementById ( 'ksi-iframe' );
    if ( ifr !== null ){
      ifr.style.display = 'none' ;
      ifr.addEventListener ( 'load', ()=>{
        document.getElementById ( 'ksi-spin-image' ).style.display = 'none';
        ifr.style.display = 'block' ;      
      });
    }      
    
  }
    
  getUrlReservationForm ( idOffer, idTrip ){ return `${this.pageUrl}createReservation_${idTrip}_${idOffer}_moduleOnly.html`; }
  getUrlOnlyTrips ( idOffer ){ return `${this.pageUrl}osw,,${idOffer}?pageTemplate=moduleOnly&offerTemplate=onlyTrips`; }
  getUrlOnlyTabs  ( idOffer ){ return `${this.pageUrl}osw,,${idOffer}?pageTemplate=moduleOnly&offerTemplate=onlyTabs`; }
  getUrlOffer ( idOffer, idTrip ){ return `${this.pageUrl}osw,,${idOffer},,,,,,,,,,,,,,,,,,${idTrip}?pageTemplate=moduleOnly&offerTemplate=onlyOffer`; }

  showReservationForm ( idOffer, idTrip, title ){
    if ( title === undefined ) title = "" ;
    let url = this.getUrlReservationForm ( idOffer, idTrip );
    let content = `<iframe src="${url}" class='ksi-iframe' id='ksi-iframe'></iframe>`+this.spinImage;
    this.open( title, content );
  }
  
  showOfferTrips ( idOffer, title ){
    if ( title === undefined ) title = "" ;
    let url = this.getUrlOnlyTrips ( idOffer );
    let content = `<iframe src="${url}" class='ksi-iframe' id='ksi-iframe'></iframe>`+this.spinImage;
    this.open( title, content );
  }
  
  showOfferTabs ( idOffer, title ){
    if ( title === undefined ) title = "" ;
    let url = this.getUrlOnlyTabs ( idOffer );
    let content = `<iframe src="${url}" class='ksi-iframe' id='ksi-iframe'></iframe>`+this.spinImage;
    this.open( title, content );    
  }

  showOffer ( idOffer, idTrip, title ){
    if ( title === undefined ) title = "" ;
    let url = this.getUrlOffer ( idOffer, idTrip );
    let content = `<iframe src="${url}" class='ksi-iframe' id='ksi-iframe'></iframe>`+this.spinImage;
    this.open( title, content );    
  }
  
}
